import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';

const ArtworkCard = ({ illustration, onAddToCart, showPrice = true }) => {
  const handleAddClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onAddToCart();
  };

  return (
    <Link to={`/galleria/${illustration.id}`} className="block">
      <div className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow cursor-pointer h-full">
        {/* Image Container */}
        <div className="relative w-full aspect-square overflow-hidden bg-brand-light">
          <img
            src={illustration.image_url || 'https://via.placeholder.com/300'}
            alt={illustration.name}
            className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
          />
          {/* Overlay on hover */}
          <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-4">
            <button
              onClick={handleAddClick}
              className="bg-brand-dark text-white px-4 py-2 rounded-lg font-body font-medium flex items-center gap-2 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 text-sm hover:bg-opacity-90"
            >
              <Plus size={16} />
              Aggiungi al carrello
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-4">
          <h3 className="font-display text-lg italic text-brand-dark mb-1 line-clamp-1">
            {illustration.name}
          </h3>
          <p className="text-sm text-brand-muted mb-3 line-clamp-2">
            {illustration.description || 'Opera senza descrizione'}
          </p>
          {showPrice && (
            <p className="font-display text-xl font-semibold text-brand-dark">
              €{Number(illustration.selling_price).toFixed(2)}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ArtworkCard;
